import * as React from "react";
const SvgChevronUp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", fill: "none", viewBox: "0 0 14 9", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 1.5, d: "M13 8 7 2 1 8" }));
export {
  SvgChevronUp as default
};
//# sourceMappingURL=chevron-up.js.map
